//This file holds the notes array used by the notes section and the 
//methods that act upon it.

import {v4 as uuidv4} from 'uuid'  //Note renamed import
import moment from 'moment';

//The notes array.
//NOTE: Due to the nature of web programming, each webpage has its 
//own copy this array. The copies must be kept consistant by the 
//storage callback functions. 
let notes;

//Function to get all saved notes.
const getNotes = () => notes;

//Function to load notes and keep storage consistant.
const loadNotes = () => {
    //Get stored notes an JSON.
    const notesJSON = localStorage.getItem('notes');

    //Try to parse notes.
    try {
        notes = notesJSON ? JSON.parse(notesJSON) : [];
    } catch (e) {
        notes = [];
    }
}

//Function to save notes. (NOT exported.)
const saveNotes = () => {
    localStorage.setItem('notes', JSON.stringify(notes));
}

//Function to create a new note and return its ID.
const createNote = () => {
    //Create new note object.
    const timestamp = moment().valueOf();
    const id = uuidv4();
    const newNote = {
        id: id,
        title: '',
        body: '',
        createdAt: timestamp,
        updatedAt: timestamp
    };

    //Add new note to array.
    notes.push(newNote);

    //Save updated array.
    saveNotes();

    //Return the note's id.
    return id;
}

//Function to remove the note with the given unique ID.
const removeNote = (id) => {
    const index = notes.findIndex((note) => note.id === id);

    if (index > -1) {
        //A note to remove has been found.
        notes.splice(index, 1);
        saveNotes();
    }
}

//Helper function for below to get the title of the given note
//as seen by the user.
const getShownTitle = (note) => {
    if (note.title.trim()) {
        return note.title.trim();
    } else {
        return 'Untitled note';
    }
} 

//Function to sort the note list.
const sortNotes = (sortBy) => {
    //Return Object.
    let sortedNotes;

    //Sort Notes based on parameter.
    if (sortBy === 'byEdited') {
        sortedNotes = notes.sort((a, b) => {
            if (a.updatedAt > b.updatedAt) {
                return -1;
            } else if (b.updatedAt > a.updatedAt) {
                return 1;
            } else {
                return 0;
            }
        });
    } else if (sortBy === 'byCreated') {
        sortedNotes = notes.sort((a, b) => {
            if (a.createdAt > b.createdAt) {
                return -1;
            } else if (b.createdAt > a.createdAt) {
                return 1;
            } else {
                return 0;
            }
        });
    } else { //alphabetical
        sortedNotes = notes.sort((a, b) => {
            if (getShownTitle(a).toLowerCase() 
                < getShownTitle(b).toLowerCase()) {
                return -1;
            } else if (getShownTitle(b).toLowerCase() 
                < getShownTitle(a).toLowerCase()) {
                return 1;
            } else {
                return 0;
            }
        });
    }

    //Return sorted list.
    return sortedNotes;
}

//Function to update a note by ID. The second parameter is an
//object that can have the fields title and body. If present,
//they indicate that that note field is to be updated. This
//function returns undefined if the update fails or the updated
//note otherwise.
const updateNote = (id, updates) => {
    //Find the note to update.
    const foundNote = notes.find((note) => note.id === id);

    //Abort if there was no note found.
    if (!foundNote) {
        return undefined;
    }

    //Update note title if given.
    if (typeof updates.title === 'string') {
        foundNote.title = updates.title;
        foundNote.updatedAt = moment().valueOf();
    }

    //Update note body if given.
    if (typeof updates.body === 'string') {
        foundNote.body = updates.body;
        foundNote.updatedAt = moment().valueOf();
    }

    //Save updated array.
    saveNotes();

    //Return updated note.
    return foundNote;
}

//Do initial note load.
loadNotes();

//Export functions.
export {getNotes, createNote, removeNote, sortNotes, 
    updateNote, loadNotes};